/* eslint-disable react/button-has-type */
import React, { memo } from 'react';
import './Button.scss';
import classnames from 'classnames';

interface Props {
    value: string | React.ReactNode,
    name?: string | undefined,
    type?: 'button' | 'submit' | 'reset' | undefined,
    isSecondary?: boolean,
    isFullWidth?: boolean,
    isBig?: boolean,
    isOutline?: boolean,
    isDisabled?: boolean,
    onButtonClick?: ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void) | undefined,
}

const Button: React.FC<Props> = ({
  value, name = '', type = 'button', onButtonClick = () => {},
  isSecondary = false, isFullWidth = false, isOutline = false, isDisabled = false, isBig = false,
}): JSX.Element => {
  const classes = classnames({
    'nw-button': true,
    'nw-button--outline': isOutline,
    'nw-button--secondary': isSecondary,
    'nw-button--fullwidth': isFullWidth,
    'nw-button--big': isBig,
    'nw-button--disabled': isDisabled,
  });
  return (
    <>
      <button
        className={classes}
        name={name}
        type={type}
        onClick={onButtonClick}
        disabled={isDisabled}
      >
        {value}
      </button>
    </>
  );
};

export default memo(Button);
